import axios from 'axios';

const API_URL = 'http://localhost:5001/api';

// Get the JWT token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Create a new tarot reading
export const createReading = async (readingData) => {
  try {
    const response = await axios.post(`${API_URL}/readings`, readingData, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get remaining readings for today
export const getRemainingReadings = async () => {
  try {
    const response = await axios.get(`${API_URL}/readings/remaining`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get reading history (requires authentication)
export const getReadingHistory = async () => {
  try {
    const response = await axios.get(`${API_URL}/readings/history`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}; 